import axios from "axios";
import React, { useState } from "react";
import { ApiConnectionString } from "../constants/ApiConntection";
import LoadingSpinner from "../components/LoadingSpinner";
import ReCAPTCHA from "react-google-recaptcha";
import { Link } from "react-router-dom";

export default function Register() {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [agree, setAgree] = useState(false);
  const [validated, setValidated] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [complete, setComplete] = useState(false);
  const [capVal, setCapVal] = useState(null);

  const passwordMatch = password && confirm && password === confirm;

  const submit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setValidated(true);

    const form = e.currentTarget;
    if (!form.checkValidity() || !passwordMatch) {
      setIsLoading(false);
      return;
    }

    try {
      const createPendingAppUser = {
        firstName,
        lastName,
        email,
        password,
      };
      const pendingAccResponse = await axios.post(
        `${ApiConnectionString}/api/PendingAppUser`,
        createPendingAppUser
      );

      if (pendingAccResponse.status === 200) {
        setComplete(true);
        setCapVal(null);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div>
        <LoadingSpinner />
      </div>
    );
  }

  if (complete) {
    return (
      <section className="">
        <div className="container py-5">
          <div className="row justify-content-center">
            <div className="col-sm-10 col-md-8 col-lg-6">
              <div className="card border-0 shadow-sm">
                <div className="card-body p-4 text-center">
                  <div className="mb-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="56"
                      height="56"
                      viewBox="0 0 24 24"
                      fill="none"
                      className="mx-auto"
                    >
                      <circle cx="12" cy="12" r="12" fill="#22c55e" />
                      <path
                        d="M7 12.5l3 3 7-7"
                        stroke="#fff"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <h1 className="fw-bold mb-2">Account created</h1>
                  <p className="text-muted mb-4">
                    Welcome{firstName ? `, ${firstName} ${lastName}` : ""}! Your
                    account has been created.
                    <br />
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="#007bff"
                      className="me-1"
                    >
                      <path d="M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 4-8 5-8-5V6l8 5 8-5v2z" />
                    </svg>
                    Please verify your email address before logging in. Check
                    your inbox and junk folder for the verification email.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="">
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-sm-10 col-md-8 col-lg-6">
            <div className="custom-card-light border-0 shadow-sm">
              <div className="card-body p-4">
                <h1 className="fw-bold mb-2">Create account</h1>
                <p className="text-muted mb-4">Join ChatBox and get started</p>

                <form
                  onSubmit={submit}
                  noValidate
                  className={`needs-validation ${
                    validated ? "was-validated" : ""
                  }`}
                >
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label">First name</label>
                      <input
                        className="form-control"
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                        required
                      />
                      <div className="invalid-feedback">
                        Enter your first name
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Last name</label>
                      <input
                        className="form-control"
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                        required
                      />
                      <div className="invalid-feedback">
                        Enter your last name
                      </div>
                    </div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Email</label>
                    <input
                      type="email"
                      className="form-control"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                    <div className="invalid-feedback">Enter a valid email</div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Password</label>
                      <input
                        type="password"
                        className="form-control"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        minLength={6}
                      />
                      <div className="form-text">At least 6 characters</div>
                      <div className="invalid-feedback">Enter a password</div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Confirm password</label>
                      <input
                        type="password"
                        className={`form-control ${
                          confirm ? (passwordMatch ? "is-valid" : "is-invalid") : ""
                        }`}
                        value={confirm}
                        onChange={(e) => setConfirm(e.target.value)}
                        required
                      />
                      <div className="invalid-feedback">Passwords must match</div>
                    </div>
                  </div>

                  <div className="form-check mb-4">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="agree"
                      checked={agree}
                      onChange={(e) => setAgree(e.target.checked)}
                      required
                    />
                    <label className="form-check-label" htmlFor="agree">
                      I agree to the terms and privacy
                    </label>
                    <div>
                      <Link to="/privacy">Privacy Policy</Link> | <Link to="/agreement">User Agreement</Link>
                    </div>
                    <div className="invalid-feedback">
                      You must agree before continuing
                    </div>
                  </div>

                  <div className="mb-3 d-flex justify-content-center">
                    <ReCAPTCHA
                      sitekey="6LeXa0QqAAAAAOMfVHItB7SWzaKJZCQg0XeM6_d2"
                      onChange={(val) => setCapVal(val)}
                    />
                  </div>

                  {!capVal ? (
                    <button
                      type="submit"
                      disabled={true}
                      className="btn brand-purple-inline w-100"
                    >
                      Create account
                    </button>
                  ) : (
                    <button
                      type="submit"
                      className="btn brand-purple-inline w-100"
                      disabled={isLoading}
                    >
                      {isLoading ? "Creating..." : "Create account"}
                    </button>
                  )}
                </form>

                <div className="text-center mt-4">
                  <span className="text-muted">Already have an account</span>{" "}
                  <a href="/login" className="text-decoration-none">
                    Login
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
